import io from "socket.io-client";
// const sockets = io.connect('https://backend-prod.invictaa.com/api/v1', { transports: ['websocket'] });
const sockets = io.connect("https://adminpanelx.inivictaa.com", {
  transports: ["websocket"],
});
// console.log(sockets);
export default sockets;
